export const getCurrentTime = () => {
    return Date.now();
};
